import Parcel from 'single-spa-react/lib/esm/parcel'
import { getSession, getCompanyMerchantId } from '../../utils/api'
import { mfeConfigs } from '../../utils/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'
import React from 'react'

export const LoyaltyProviderPage = (props) => {
  const session = getSession()
  const authToken = session && session.accessToken
  const merchantId = getCompanyMerchantId()
  const filterConfig = {
    platform: 'pos',
    tenantName: props.tenantName,
    onProvidersChange: props.onProvidersChange,
    loyaltyActions: ['CONFIG'],
  }

  return (
    <SingleSpaParcel
      {...props}
      basename="settings/company/loyalty"
      authToken={authToken}
      merchantId={merchantId}
      filterConfig={filterConfig}
      config={mfeConfigs.LOAD_LOYALTY_PAGE}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/MfeParcels/LoyaltyProviderPage.js